import { useContext, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../../../../context/AuthContext";
import {
  InnerWrapper,
  MainContainer,
  PINScreen,
  TitleAndActionBox,
} from "../../../common";
import { Grid } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import BusinessLoader from "../../../common/BusinessLoader";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { handleApi } from "../../../../apis";
import {
  ACCOUNT_PIN_RESET,
  CHECK_PIN_GET,
} from "../../../../apis/configuration";
import { ArrowIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./../WalletMain.module.css";
import { ParagraphText } from "../../../../Libraries";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { clearLocalStorageExcludeSomeFields } from "../../../../utils";
import { useWalletContext } from "../../../../context/WalletContext";
const VerifyPin = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { handleLogoutInDB, user, setPinVerified, pinVerified } =
    useAuthContext();
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const { KYCVerified,EMIVerified } = useWalletContext();

  const lastVisited = localStorage.getItem("lastVisited");
  const prevRoute = location.state?.prevRoute || lastVisited || "/Accounts";

  if (!user?.phone_number || !EMIVerified) {
    return <Navigate to={prevRoute} replace />;
  }

  // If the user already verified (e.g. back-button navigated here), skip the screen.
  if (pinVerified && location.pathname?.toLowerCase() !== "/ucash/verifypin") {
    return <Navigate to={prevRoute} replace />;
  }

  const getPIN = async (pin) => {
    try {
      setError("");
      setLoading(true);
      const response = await handleApi(
        CHECK_PIN_GET,
        {
          rnp_verify: true,
          pin,
        },
        null,
        navigate,
        { "Web-Token": Cookies.get("deviceId") },
      );

      if (response.success) {
        setLoading(false);
        sessionStorage.removeItem("verifyPinInStack");
        setPinVerified(true);
        navigate(prevRoute, { replace: true });
      } else {
        setLoading(false);
        if (response?.data?.is_locked) {
          showSnackbar({
            message:
              response?.data?.message ||
              I18n.account_locked_contact_support,
            severity: "error",
          });

          let phoneNumber = localStorage.getItem("phone_number");

          handleLogoutInDB(navigate);
          if (!KYCVerified) {
            navigate("/ForgotPin", {
              state: {
                phone: phoneNumber,
              },
            });
          } else {
            navigate("/", {
              state: {
                isVerifyAccountScreen: true,
              },
            });
          }
        }
        if (response.message && response.attempts_left) {
          setError(
            `${response.message} (${response.attempts_left} ${I18n.tries_left})`,
          );
        }
      }
    } catch (error) {
      let data = error?.response?.data;
      if (data?.is_locked) {
        showSnackbar({
          message:
            data?.message ||
            I18n.account_locked_contact_support,
          severity: "error",
        });

        let phoneNumber = localStorage.getItem("phone_number");

        clearLocalStorageExcludeSomeFields();
        if (!KYCVerified) {
          navigate("/ForgotPin", {
            state: {
              phone: phoneNumber,
            },
          });
        } else {
          navigate("/", {
            state: {
              isVerifyAccountScreen: true,
            },
          });
        }
      }
      setLoading(false);
    }
  };

  const handleForgotPIN = async () => {
    const phone = localStorage.getItem("phone_number");
    try {
      setLoading(true);
      const response = await handleApi(
        ACCOUNT_PIN_RESET,
        { phone_number: phone },
        null,
        navigate,
        { "Api-Key": process.env.REACT_APP_API_KEY },
      );
      const isVerified = response?.verified;
      if (Boolean(isVerified)) {
        sessionStorage.setItem("forgotPinVerify", JSON.stringify({ phone: phone || "" }));
      }
      await handleLogoutInDB(navigate);
      if (Boolean(isVerified))
        navigate("/", {
          replace: true,
          state: { isVerifyAccountScreen: true, phoneNumber: phone },
        });
      else {
        navigate("/ForgotPin", { state: { phone: phone } });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <MainContainer fluid className="h-100 verifyPinWrapper">
      <BusinessLoader loadBusiness={loading} />
      <Grid container className="h-100">
        <Grid item md={12} className="h-100" >
          <TitleAndActionBox
            data={{
              title: I18n.verify_PIN,
            }}
          >
            <ParagraphText
              id="verify_pin_forgot_pin_link"
              className={styles.AccountRightSection}
              onClick={() => {
                triggerLogEvent(analytics, "w_forgot_pin");
                handleForgotPIN();
              }}
            >
              {I18n.forgot_pin}
            </ParagraphText>
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              height={"100%"}
            >
              <PINScreen
                error={error}
                title={I18n.verify_PIN}
                description={I18n.Please_verify_your_4_digits_Udhaar_book_PIN}
                onChangeQuery={getPIN}
                id="verify_pin"
              />
            </Box>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default VerifyPin;
